import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import firebaseApp from 'config/firebase';
import Header from 'components/Header';
import Button from 'components/Button';
import TextInput from 'components/TextInput';

import './index.css';

function PasswordReset() {
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    const auth = getAuth(firebaseApp);

    const resetPassword = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        sendPasswordResetEmail(auth, email)
            .then(() => {
                setEmailSent(true);
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <>
            <Helmet>
                <title>
                    Reset Password - Test Center Admin
                </title>
            </Helmet>
            <Header title='Reset Password' />
            {emailSent
            ?   <p className='password-reset__message'>
                    We have a sent a password reset link to <u>{email}</u>.<br/>
                    Please check your inbox.
                </p>
            :   <form className='password-reset' onSubmit={resetPassword}>
                    <TextInput
                        className='password-reset__input'
                        label='email'
                        placeholder='enter email'
                        type='email'
                        value={email}
                        onChange={event => setEmail(event.target.value)}
                        required
                    />
                    <Button
                        className='password-reset__button'
                        type='submit'
                    >
                        Reset Password
                    </Button>
                </form>
            }
            <Link className='password-reset__signIn' to='/sign-in'>
                Back to sign in
            </Link>
        </>
    );
}

export default PasswordReset;